export function safeHttpUrl(value: string | undefined): string | null {
  if (!value) return null;
  try {
    const url = new URL(value);
    return url.protocol === "https:" || url.protocol === "http:" ? value : null;
  } catch {
    return null;
  }
}

export function safeLinkedInUrl(value: string | undefined): string | null {
  const safeUrl = safeHttpUrl(value);
  if (!safeUrl) return null;
  const url = new URL(safeUrl);
  const hostname = url.hostname.toLocaleLowerCase();
  return url.protocol === "https:" &&
    (hostname === "linkedin.com" || hostname.endsWith(".linkedin.com"))
    ? safeUrl
    : null;
}
